import {useAccount, useIsAuthenticated} from '@azure/msal-react';
import {useEffect, useState} from 'react';
import {devBypassRoles, isDevBypassEnabled} from 'src/app/constants/config/devBypassConfig';
import {UserRoleConfig, allowTo} from 'src/app/utilities/helpers/userRole';
import {Roles} from 'src/data/enums/roles';

export const useAllowedRoutes = () => {
    const isLoggedIn = useIsAuthenticated();

    const [allowedRoutes, setAllowedRoutes] = useState<UserRoleConfig | undefined>();
    const account = useAccount();

    useEffect(() => {
        if (isDevBypassEnabled) {
            setAllowedRoutes(allowTo(devBypassRoles as Roles[]));
            return;
        }

        if (!account) return;

        setAllowedRoutes(allowTo((account?.idTokenClaims?.roles || []) as Roles[]));
    }, [isLoggedIn, account]);

    return allowedRoutes;
};
